import { CSSProperties, PropsWithChildren } from 'react';

import classNames from 'classnames';

export interface TableRowProps {
  style?: CSSProperties;
  hasBorder?: boolean;
}

export const TableRow = ({
  children,
  style,
  hasBorder = true,
}: PropsWithChildren<TableRowProps>) => (
  <div className={classNames(hasBorder && 'border-b border-base-border-medium')} style={style}>
    {children}
  </div>
);
